export function formatNumber(value: number = 0): string {
  return new Intl.NumberFormat('da-DK').format(value)
}

export function formatCurrency(value?: number): string {
  if (typeof value !== 'number' || value == null) return ''

  return new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' }).format(value)
}

export function isDefined(values: any[]): void {
  values.forEach(value => {
    if (value === undefined || value === null) throw 'Something is not defined!'
  })
}

export type NullOrUndefined = null | undefined

const AVG_KM_PER_YEAR = 20000

export function estimateOldMileage(registrationYear: number, maxStartMileage: number, currentYear: number = new Date().getFullYear()): number {
  return Math.min((currentYear - registrationYear) * AVG_KM_PER_YEAR, maxStartMileage)
}

export function calculateMaxYearlyMileage(
  agreementType: { maxStartMileage?: number, maxTotalMileage?: number } | null | undefined,
  defaults: { maxYearlyMileage: number, maxTotalMileage: number },
  oldMileage: number | undefined,
  duration: number | undefined
): number {
  if (!duration) {
    return defaults.maxYearlyMileage
  }

  if (agreementType?.maxStartMileage) {
    const remaining = (agreementType.maxTotalMileage ?? defaults.maxTotalMileage) - (oldMileage ?? 0)
    return Math.round((remaining / duration / 5000)) * 5000
  }

  return defaults.maxYearlyMileage
}

export type MileageTier = 'thisMonth' | 'thisYear' | 'older'

// registrationMonth is 0-indexed, matching VehicleSearchResult.registrationMonth and Date's month arg.
// Falls back to 'thisYear' (never assumes 'thisMonth') when the month is unknown.
export function getMileageTier(registrationYear?: number, registrationMonth?: number, now: Date = new Date()): MileageTier {
  if (registrationYear !== now.getFullYear()) return 'older'
  if (registrationMonth != null && registrationMonth === now.getMonth()) return 'thisMonth'
  return 'thisYear'
}

export function getMonthName(index: number): string {
  const date = new Date(2000, index, 1)
  return new Intl.DateTimeFormat('da-DK', { month: 'long' }).format(date)
}